import { render, staticRenderFns } from "./ModalAuditoriaTemplate.vue?vue&type=template&id=5635fb55&scoped=true&"
import script from "./ModalAuditoriaTemplate.vue?vue&type=script&lang=js&"
export * from "./ModalAuditoriaTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ModalAuditoriaTemplate.vue?vue&type=style&index=0&id=5635fb55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5635fb55",
  null
  
)

export default component.exports